import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom'

function Page404() {
    const dispatch = useDispatch()
    
    useEffect( () => {
        dispatch({ type: 'loadingChange', payload: false })
        dispatch({ type: 'pageChange', payload: 'page404' })
    },
    // eslint-disable-next-line
    []);

    return (
        <section className="appoinment section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="mt-3">
                            <div className="feature-icon mb-3">
                            <i className="icofont-support text-lg"></i>
                            </div>
                            <span className="h3">404 Error (페이지가 없습니다.)</span>
                            <br /><br />
                            <span className="h5">같은 증상이 반복되는 경우 조합으로 연락주세요</span>
                            <br /><br />
                            <hr />
                            <br />
                        </div>

                        <Link className="btn btn-main btn-round-full" to="/">홈으로 이동<i className="icofont-simple-right ml-2"></i></Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Page404